// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var DocumentationLegacyPageAssetType;
(function (DocumentationLegacyPageAssetType) {
    DocumentationLegacyPageAssetType["image"] = "image";
    DocumentationLegacyPageAssetType["figmaFrame"] = "figmaFrame";
})(DocumentationLegacyPageAssetType || (DocumentationLegacyPageAssetType = {}));
